module.exports = __webpack_public_path__ + "static/Existentialism-4e72920f0f934ab9ea01f555c5a8c87a.png";